/** Same text key as Popty's clip-index/normalizeForAudio. Keep question marks. */
export function knownTextKey(text: string): string {
  const t = text.replace(/\s+/g, ' ').toLowerCase().trim()
  return /[?？][.!?。？！]*$/.test(t)
    ? t.replace(/\s*[.!?。？！¡]*[?？][.!?。？！]*$/, '?')
    : t.replace(/[.?!¿¡。？！]+$/, '')
}
export interface KnownVoiceCatalogue {
  menu?: import('./clipMenu').CourseClipMenu
  narrations?: Record<string, Record<string, string>>
  narrationCoverage?: { total: number; coverage: Record<string, number> }
  total: number
  voices: Array<{ id: string; name: string; covered: number }>
  clips: Record<string, Record<string, string>>
}
export const ENGLISH_KNOWN_DEFAULTS = [
  'cartesia_d293d509-eb96-4df4-8cfd-80a693aa49a9', // Tom-006
  'cartesia_71a7ad14-091c-4e8e-a314-022ece01c121', // Charlotte
]
export function chooseKnownVoiceUrl(url: string, text: string | undefined, voice: string, catalogue: KnownVoiceCatalogue | undefined, offline: boolean, cached: (id: string) => boolean, language?: string): string {
  if (!catalogue) return url
  const originalId = url.match(/\/api\/audio\/([^?/#]+)/)?.[1]?.replace(/\.v\d+$/, '')
  // Narrations are indexed by presentation identity. Never feed a LEGO's
  // translation text into the prompt index for an introduction.
  const variants = text ? catalogue.clips[knownTextKey(text)]
    : originalId ? catalogue.narrations?.[originalId] : undefined
  const preferences = [voice, ...(['eng', 'en'].includes(language || '') ? ENGLISH_KNOWN_DEFAULTS : [])].filter(Boolean)
  for (const preference of preferences) {
    const id = variants?.[preference]
    if (id && (!offline || cached(id))) {
      return url.replace(/(\/api\/audio\/)[^?/#]+/, `$1${id}`)
    }
  }
  return url
}
